<h2 mat-dialog-title>{{title}} </h2>
<mat-dialog-content>
    <div class="info-container"><mat-icon matTooltip="The password needs to have a minimum of eight characters, at least one letter, one number and one special
        character.">info</mat-icon></div>
    <form [formGroup]="form" autocomplete="off" class="container">
        <mat-form-field appearance="outline" autocomplete="off" class="form-field">
            <mat-label>E-Mail</mat-label>
            <input matInput autoComplete="off" formControlName="email">
        </mat-form-field>
        <mat-form-field title="Minimum eight characters, at least one letter, one number and one special character"
            appearance="outline" class="form-field" autocomplete="off">
            <mat-label>Password</mat-label>
            <input *ngIf="isPasswordVisible" matInput autoComplete="off" formControlName="password" type="text">
            <input *ngIf="!isPasswordVisible" matInput autoComplete="off" formControlName="password" type="password">
            <mat-icon *ngIf="!isPasswordVisible" title="Show Password" matSuffix class="visibility"
                (click)="visibilityPassword()">
                visibility</mat-icon>
            <mat-icon *ngIf="isPasswordVisible" title="Hide Password" matSuffix class="visibility"
                (click)="visibilityPassword()">
                visibility_off</mat-icon>
        </mat-form-field>
        <mat-form-field title="Minimum eight characters, at least one letter, one number and one special character"
            appearance="outline" class="form-field" autocomplete="off">
            <mat-label>Repeat Password</mat-label>
            <input *ngIf="isPasswordRepeatVisible" matInput autoComplete="off" type="text" onpaste="return false;"
                ondrop="return false;" formControlName="repeatPassword">
            <input *ngIf="!isPasswordRepeatVisible" matInput autoComplete="off" type="password" onpaste="return false;"
                ondrop="return false;" formControlName="repeatPassword">
            <mat-icon *ngIf="!isPasswordRepeatVisible" title="Show Password" matSuffix class="visibility"
                (click)="visibilityPasswordRepeat()">
                visibility</mat-icon>
            <mat-icon *ngIf="isPasswordRepeatVisible" title="Hide Password" matSuffix class="visibility"
                (click)="visibilityPasswordRepeat()">
                visibility_off</mat-icon>
        </mat-form-field>
        <mat-form-field class="form-field" *ngIf="data.user.roleId === 1">
            <mat-label>Select Company</mat-label>
            <mat-select formControlName="companyId" [(value)]="companyId">
                <mat-option class="select-without-checkbox" *ngFor="let company of companies" [value]="company.id">
                    {{company.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <div *ngIf="errors.length > 0" class="validation-status">
            <p *ngFor="let error of errors">{{error}}</p>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button class="color" (click)="cancel()">{{button1}}</button>
    <span class="spacer"></span>
    <button mat-button class="color" (click)="createUser()" cdkFocusInitial>{{button2}}</button>
</mat-dialog-actions>